module.exports = __webpack_public_path__ + "img/hr-tree-05-c-leaves.f615d5ca.png";